import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetRootComponent } from 'Components/Worksheets/Core/types';
import { TestProcedure } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/BsEn/types';
import ids from 'Components/Worksheets/QestIds';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';
import {
  AnnexACoarsePortionWashingSection,
  AnnexAFinePortionSubspecimenWashingSection,
  ResultsSection,
  WashingSection,
} from './Sections';

const qestIds = [ids.wash.BS_EN_933_1.Rev2012];

let MeasuredWashSievingBsEnWorksheet: WorksheetRootComponent = ({ createWorksheetSelector, namePrefix }) => {
  const isAnnexA = useSelector(
    pipe(createWorksheetSelector!('data.Preparation.Method', false), (m) => m === TestProcedure.AnnexA)
  );
  const isCoarsePortion = namePrefix!.endsWith('Separation.CoarsePortion.Washing.AssociatedWashTest.MeasuredTest');

  return (
    <>
      {isAnnexA ? (
        isCoarsePortion ? (
          <AnnexACoarsePortionWashingSection />
        ) : (
          <AnnexAFinePortionSubspecimenWashingSection />
        )
      ) : (
        <>
          <WashingSection />
          <ResultsSection />
        </>
      )}
    </>
  );
};

MeasuredWashSievingBsEnWorksheet.qestIds = qestIds;
MeasuredWashSievingBsEnWorksheet = withInjectedProps(MeasuredWashSievingBsEnWorksheet);

export default MeasuredWashSievingBsEnWorksheet;
export { MeasuredWashSievingBsEnWorksheet };
